import { render, staticRenderFns } from "./CallForwardingNumberInputModal.vue?vue&type=template&id=a130f4a8&"
import script from "./CallForwardingNumberInputModal.vue?vue&type=script&lang=js&"
export * from "./CallForwardingNumberInputModal.vue?vue&type=script&lang=js&"
import style0 from "./CallForwardingNumberInputModal.vue?vue&type=style&index=0&id=a130f4a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports